(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["keauty-home-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('keauty-home-carousel')) {
    customElements.define('keauty-home-carousel', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.slides = Array.from(this.querySelectorAll('[data-keauty-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-keauty-dot]'));
        this.previousButton = this.querySelector('[data-keauty-previous]');
        this.nextButton = this.querySelector('[data-keauty-next]');
        this.pauseButton = this.querySelector('[data-keauty-toggle]');
        this.status = this.querySelector('[data-keauty-status]');
        this.current = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
        this.interval = Math.max(5000, Number(this.dataset.interval) || 6000);
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.autoplayEnabled = this.dataset.autoplay === 'true' && !this.reducedMotion;
        this.userPaused = !this.autoplayEnabled;
        this.interactionPaused = false;

        if (this.slides.length < 2) return;

        this.previousButton?.addEventListener('click', () => this.goTo(this.current - 1, true));
        this.nextButton?.addEventListener('click', () => this.goTo(this.current + 1, true));
        this.dots.forEach((dot) => {
          dot.addEventListener('click', () => this.goTo(Number(dot.dataset.keautyDot), true));
        });
        this.pauseButton?.addEventListener('click', () => this.toggleAutoplay());
        this.addEventListener('pointerenter', () => this.setInteractionPaused(true));
        this.addEventListener('pointerleave', () => this.setInteractionPaused(false));
        this.addEventListener('focusin', () => this.setInteractionPaused(true));
        this.addEventListener('focusout', () => {
          requestAnimationFrame(() => {
            if (!this.contains(document.activeElement)) this.setInteractionPaused(false);
          });
        });

        if (!this.autoplayEnabled && this.pauseButton) this.pauseButton.hidden = true;
        this.updateSlides(false);
        this.updatePauseControl();
        this.startTimer();
      }

      disconnectedCallback() {
        this.stopTimer();
      }

      goTo(index, announce) {
        const count = this.slides.length;
        this.current = (index + count) % count;
        this.updateSlides(announce);
        this.restartTimer();
      }

      updateSlides(announce) {
        this.slides.forEach((slide, index) => {
          const active = index === this.current;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
          slide.toggleAttribute('inert', !active);
        });
        this.dots.forEach((dot, index) => {
          if (index === this.current) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
        if (this.status) {
          if (announce) {
            const heading = this.slides[this.current]?.dataset.slideHeading || '';
            this.status.textContent = `Slide ${this.current + 1} of ${this.slides.length}: ${heading}`;
          } else {
            this.status.textContent = '';
          }
        }
      }

      toggleAutoplay() {
        this.userPaused = !this.userPaused;
        this.updatePauseControl();
        if (this.userPaused) this.stopTimer();
        else this.startTimer();
      }

      updatePauseControl() {
        if (!this.pauseButton) return;
        const paused = this.userPaused;
        const pauseIcon = this.pauseButton.querySelector('[data-keauty-pause-icon]');
        const playIcon = this.pauseButton.querySelector('[data-keauty-play-icon]');
        this.pauseButton.setAttribute('aria-pressed', paused ? 'true' : 'false');
        this.pauseButton.setAttribute(
          'aria-label',
          paused ? this.pauseButton.dataset.playLabel : this.pauseButton.dataset.pauseLabel
        );
        if (pauseIcon) pauseIcon.hidden = paused;
        if (playIcon) playIcon.hidden = !paused;
      }

      setInteractionPaused(paused) {
        this.interactionPaused = paused;
        if (paused) this.stopTimer();
        else this.startTimer();
      }

      startTimer() {
        if (!this.autoplayEnabled || this.userPaused || this.interactionPaused || this.timer) return;
        this.timer = window.setInterval(() => this.goTo(this.current + 1, false), this.interval);
      }

      stopTimer() {
        if (!this.timer) return;
        window.clearInterval(this.timer);
        this.timer = null;
      }

      restartTimer() {
        this.stopTimer();
        this.startTimer();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  class KeautyAddAll extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-keauty-add-all]');
      this.status = this.querySelector('.keauty-routine__status');
      this.button?.addEventListener('click', () => this.add());
    }

    async refresh(sections) {
      const root = window.Shopify?.routes?.root || '/';
      const cart = await (await fetch(`${root}cart.js`, { credentials: 'same-origin', cache: 'no-store' })).json();
      if (sections) cart.sections = sections;
      document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart } }));
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true, detail: { cart, openMiniCart: window.themeVariables?.settings?.cartType === 'drawer' }
      }));
    }

    async add() {
      const ids = (this.dataset.variantIds || '').split(',').filter(Boolean).map(Number);
      if (!ids.length || !this.button || this.button.disabled) return;
      const root = window.Shopify?.routes?.root || '/';
      this.button.disabled = true;
      this.button.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: ids.map((id) => ({ id, quantity: 1 })), sections: ['mini-cart'] })
        });
        const payload = await response.json();
        await this.refresh(response.ok ? payload.sections : null);
        if (this.status) this.status.textContent = response.ok ? (this.dataset.added || '') : (this.dataset.failed || '');
      } catch (error) {
        if (this.status) this.status.textContent = this.dataset.failed || '';
      } finally {
        this.button.disabled = false;
        this.button.removeAttribute('aria-busy');
      }
    }
  }

  if (!customElements.get('keauty-add-all')) customElements.define('keauty-add-all', KeautyAddAll);

  } catch(e) { console.error(e); }
})();
})();
